import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import Loader from '@cidade360/core-lib/components/Loader';
import PageLoader from '@cidade360/ui-lib/base/loader/PageLoader';
import Logout from '@/containers/Auth/Logout';
import { getEnv } from '@cidade360/core-lib/env';
import { useSessionStore } from '@cidade360/core-lib/repo/session';
const Router: any = BrowserRouter;

const Admin = Loader({
  loader: () => import('./admin'),
  fallback: PageLoader,
});

const Auth = Loader({
  loader: () => import('./auth'),
  fallback: PageLoader,
});

const Public = Loader({
  loader: () => import('./Public'),
  fallback: PageLoader,
});

const Supplier = Loader({
  loader: () => import('./supplier'),
  fallback: PageLoader,
});

function RootRedirect() {
  const env = getEnv();
  const { user } = useSessionStore();
  if (user?.applID === 'supplier') {
    return <Redirect to="/supplier" />;
  }
  return <Redirect to={env.HOME_URL || '/supplier'} />;
}

function App() {
  const env = getEnv();
  const suppliersDisabled = env.DISABLE_SUPPLIERS_MODULE === 'true';
  return (
    <Router>
      <>
        <Switch>
          <Route exact path="/">
            <RootRedirect />
          </Route>
          <Route exact path="/admin/signout" component={Logout} />
          <Route path="/auth" component={Auth} />
          <Route path="/admin" component={Admin} />
          {!suppliersDisabled && <Route path="/supplier" component={Supplier} />}
          <Route path="/public" component={Public} />
        </Switch>
      </>
    </Router>
  );
}

export default App;
